import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { addRelatedPatient } from '../../../../../lib/fetchApi'
import { notificationActions } from '../../../../../store/notifications'
import { caseActions } from '../../../../../store/case'
import { formatDateLocal } from '../../../../../lib/script'
import { formatPatientName } from '../../../../../lib/patientName'

import classes from './RelatedPatientItem.module.css'

const RelatedPatientItemAdd = ({data, closeModal}) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)    

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const addrelatedPatientHandler = async () => {
        setLoading(true)
        try {
            let reqBody = {
                related_patients: [data?.id]
            }
            let update = await addRelatedPatient(userToken, activeCase.case.id, reqBody)

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))            
            } else {
                let dispatchBody = {
                    folder: 'related_patients',
                    arr: update
                }
                dispatch(caseActions.replaceFolder(dispatchBody))
                if (closeModal) {
                    closeModal()
                }
            } 
        } finally {
            setLoading(false)
        }
    }
   

    return <button onClick={addrelatedPatientHandler} className={classes.item_add} disabled={loading}>
        <div className='flex-container'>
            <div className={classes.case}>NG{data?.person_number}</div>
            <div className={classes.name}>{formatPatientName(data, { order: 'lastFirst' })}</div>
        </div>
        <div className='flex-container'>
            <div>{formatDateLocal(data?.incident_date)}</div>
            {loading && <span className="loader dark"></span>} 
        </div>       
    </button>
}

export default RelatedPatientItemAdd